import { Outlet, useParams } from "react-router-dom";
import { useRestaurantTheme } from "@/hooks/useRestaurantTheme";

/** Everything under /restaurants/:restaurantId renders in the venue's colors. */
function RestaurantScopeLayout() {
  const { restaurantId = "" } = useParams<{ restaurantId: string }>();

  useRestaurantTheme(restaurantId);

  return <Outlet />;
}

export default RestaurantScopeLayout;
